import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';

@Component({
    selector: 'app-etf-bill-widget-settings',
    templateUrl: './etf-bill-widget.settings.component.html',
    styleUrl: './etf-bill-widget.settings.component.scss'
})
export class AppEtfBillWidgetSettingsComponent {
    @Input() widget: WidgetModel;
}